import { Row, Col } from "react-bootstrap";

import { Placeholder } from "components/Placeholder/index";
import { Heading } from "style/components/Heading.styles";
import { BlueCheckIcon } from "assets/icons";
import { Button } from "components/Button/index";
import { PLANS_LINK } from "utils/constants";
import { IconArrowRightDirection } from "assets/icons/index";

export const PurchasePlanModalPlaceholder = () => {
  return (
    <Row>
      <Col md={6} className="content-wrapper">
        <div>
          <Heading className="surmount-heading">Surmount Premium</Heading>
          <p>Invest smarter, not harder</p>

          <Placeholder as="h4" />

          <ul>
            {Array.from({ length: 6 }, (_, index) => (
              <li key={index}>
                <BlueCheckIcon
                  viewBox="0 0 23 10"
                  stroke="#048AF5"
                  strokeWidth="2"
                />

                <Placeholder as="span" />
              </li>
            ))}
          </ul>
        </div>
        <div className="pro-plan-label">
          <a href={PLANS_LINK} target="_blank" rel="noopener noreferrer">
            Professional Plan <IconArrowRightDirection />
          </a>
        </div>
      </Col>
      <Col md={6} className="price-wrapper placeholder-wrapper">
        <div className="trial-details">
          <Placeholder as="span" />
          <div>
            <div className="free-trial">
              <Placeholder as="span" />
            </div>
            <div className="sub-text">
              <Placeholder as="span" />
            </div>
          </div>
        </div>

        <div className="mb-4">
          <div className="fs-5 mb-2">
            <Placeholder as="span" className="title" />
          </div>
          <div className="d-flex flex-row align-items-center gap-2 flex-wrap mb-3">
            {/* Simulate 2-3 billing cycle radios */}
            {[1, 2].map((_, idx) => (
              <div key={idx} className="d-flex align-items-center gap-2">
                <Placeholder as="span" className="radio-button" />
                <Placeholder as="span" className="radio-label" />
                {/* Simulate badge/tag for yearly */}
                {idx === 1 && <Placeholder as="span" className="badge-label" />}
              </div>
            ))}
          </div>
        </div>

        <h2 className="mt-3">
          <Placeholder as="span" className="title" />
        </h2>
        <Row className="g-3">
          {[1, 2, 3, 4].map((_, idx) => (
            <Col md={6} sm={12} xs={12} key={idx}>
              <div className="form-check mb-3">
                <Placeholder as="span" className="radio-button" />
                <Placeholder as="span" className="radio-label" />
                <Placeholder as="span" />
                <Placeholder as="span" />
              </div>
            </Col>
          ))}
        </Row>
        <div className="due-date">
          <Placeholder as="span" className="due-date-label" />
        </div>
        <Button>
          <Placeholder as="span" className="change-premium-btn" />
        </Button>
        <div className="helptext">
          <Placeholder as="span" className="helptext-label" />
        </div>
      </Col>
    </Row>
  );
};
